export const key = {
    country: 'country',
};

export function redirect(target) {
    window.location.href = target;
}

export function goBack() {
    document.body.style.display = 'none';
    window.history.go(-1);
}

export function replaceState({ state = window.history.state, title = window.title, uri }) {
    window.history.replaceState(state, title, uri);
}

export function pushState(uri) {
    window.history.pushState(history.state, window.title, uri);
}

export function openURL(url, isNewTab) {
    window.open(url, isNewTab && '_blank');
}

export function getURL() {
    return window.location.href;
}

export function getOrigin() {
    return window.location.origin;
}

export function getPathname() {
    return window.location.pathname;
}

export function getSearchParam(param) {
    return new URLSearchParams(window.location.search).get(param);
}

export function deleteUrlParam(param) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(param);
    const newUrl = searchParams.toString().length
        ? `${getPathname()}?${searchParams}`
        : getPathname();
    window.history.replaceState({}, '', newUrl);
}

export function getParamFromURL(url, param) {
    return new URL(url, getOrigin()).searchParams.get(param);
}

export function getSearch() {
    return window.location.search;
}

export function getHash() {
    return window.location.hash;
}

export function setHash(hash = '') {
    window.location.hash = `#${hash}`;
}

export function getFullPath() {
    return `${getPathname()}${getSearch()}${getHash()}`;
}

export const getCurrentLocation = () => window.location;
